<template>
  <rpm-modal persist :open="open" class="flex flex-col gap-y-8" @close="$emit('close')">
    <div class="w-full border-b pb-3">
      <h2 class="text-xl font-bold text-left">
        Excluir Questionário
      </h2>
    </div>

    <div class="text-center flex flex-col gap-1">
      <h3 class="text-lg font-semibold">
        Questionário:
        <span class="text-red-600">
          {{ group?.label || 'Não informado' }}
        </span>
      </h3>

      <p class="text-sm text-default/80 dark:text-white/80">
        Você tem certeza que deseja excluir o grupo de questões
        <strong>ID {{ group?.id }}</strong>?
        Esta ação não poderá ser desfeita.
      </p>
    </div>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
          @click="$emit('close')"
          color="gray"
          label="Não"
      ></rpm-button>

      <rpm-button
          label="Sim, excluir"
          color="red"
          @click="deleteQuestionnaireGroup"
      ></rpm-button>
    </section>
  </rpm-modal>
</template>

<script>
import RpmModal from "#components/RpmModal.vue";
import groupRepository from "#repositories/groupRepository";

export default {
  name: 'DeleteQuestionnaireModal',
  components: {
    RpmModal
  },
  props: {
    group: {
      type: Object
    },
    open: {
      type: Boolean
    }
  },
  methods: {
    deleteQuestionnaireGroup() {
      if (!this.group || !this.group.id) {
        this.$notify('Erro: Grupo não especificado para exclusão.', 'error');
        return;
      }
      groupRepository.deleteGroup(this.group.id)
          .then(() => {
            this.$notify('Grupo de questões excluído com sucesso!', 'success');
            this.$emit('deleted');
            this.$emit('close');
          })
          .catch((error) => {
            this.$notify('Erro ao excluir grupo de questões.', 'error');
            console.error('Erro ao excluir grupo:', error);
          });
    }
  }
}
</script>